<template>
	<db-row class="mobile-base-container">
		<db-row height="auto" :id="topId" class="sticky-wrapper sticky-wrapper-top"></db-row>
		<db-row class="page-container safe-bottom auto-fill ovh">
			<router-view v-if="vueInstanceLoaded" />
		</db-row>
		<db-row class="page-masker" :class="maskerClasses" valign="middle" align="center">
			<db-blend-text :text="loadingText" />
		</db-row>
		<db-row height="auto" :id="bottomId" class="sticky-wrapper sticky-wrapper-bottom"></db-row>
		<db-dialog-manager />
	</db-row>
</template>

<script>
	import Vue from 'vue'
	import utils from '../../../utils'
	import storeModule from '../../../store'
	
	export default {
		name: 'base-container',
		
		data(){
			return {
				loadingText: this.$config.platform.loadingText || '豆包网',
				topId: 'sticky_top_' + Math.random(),
				bottomId: 'sticky_bottom_' + Math.random(),
				vueInstanceLoaded: false,
				maskerClasses: '',
				stickContainer: null,
				stickBottomContainer: null
			}
		},
		
		created(){
			setTimeout(() => {
				this.vueInstanceLoaded = true
			}, 200)
			const user = utils.getLocalItem('session_user', true)
			user && this.$store.commit('setUser', user)
			this.$store.registerModule('mobileStore', storeModule)
		},
		
		mounted(){
			this.stickContainer = document.getElementById(this.topId),
			this.stickBottomContainer = document.getElementById(this.bottomId)
		},
		
		provide(){
			const that = this
			return {
				 registStickContainer: () => {
					return {
						top: that.stickContainer,
						bottom: that.stickBottomContainer
					}
				 },
				 
				 clearStickContainer: () => {
					 console.log('stick clear')
					 that.stickContainer && (that.stickContainer.innerHTML = '')
					 that.stickBottomContainer && (that.stickBottomContainer.innerHTML = '')
				 },
				 
				 refresh(){},
				 regist(){}
			}
		},
		
		watch: {
			async ['$store.state.mobileStore.routeEffectTrigger'](val){
				if(val){
					await this.effectInit()
					await this.effectActive()
				}
			},
			
			async ['$store.state.mobileStore.routeMaskerTrigger'](val){
				val && await this.effectRemove()
			}
		},
		
		methods: {
			effectInit(){
				return new Promise((res, rej) => {
					const {effect} = this.$store.state.mobileStore
					this.maskerClasses = (effect.toLowerCase().replace(/_/g, '-') + '-init')
					setTimeout(() => {
						res()
					}, 50)
				})
			},
			
			effectActive(){
				return new Promise((res, rej) => {
					const {effect} = this.$store.state.mobileStore
					const effectName = effect.toLowerCase().replace(/_/g, '-')
					if(effectName){
						this.maskerClasses = (effectName + '-active')
						setTimeout(() => {
							Vue.$next && Vue.$next()
							res()
						}, 400)
					}else{
						res()
					}
				})
			},
			
			effectRemove(){
				return new Promise((res, rej) => {
					const {effect} = this.$store.state.mobileStore
					this.maskerClasses = (effect.toLowerCase().replace(/_/g, '-') + '-leave')
					setTimeout(async () => {
						await this.effectInit()
						res()
					}, 400)
				})
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.mobile-base-container{
		position: relative;
		background: #666;
		
		.sticky-wrapper{
			//position: fixed;
			left: 0;
			z-index: 1000;
			
			&.sticky-wrapper-top{
				//top: 0;
			}
			&.sticky-wrapper-bottom{
				//bottom: 0;
				box-shadow: -10px 0 20px rgba(#000, .1);
			}
		}
		
		.page-container{
			background: #f0f0f0;
			//position: absolute;
			position: relative;
			z-index: 2;
		}
		
		.page-masker{
			position: absolute;
			top: 0;
			left: 0;
			z-index: 3;
			opacity: 0;
			background: rgba(#f7f7f7, 1);
			transition: all .3s;
		}
		
		.none-init, .none-active, .none-leave{
			opacity: 0;
			transform: translateX(100%);
		}
		
		.slider-left-init{
			opacity: 0;
			transform: translateX(100%);
			transition: all .3s;
		}
		.slider-left-active{
			opacity: 1.0;
			transform: translateX(0);
			transition: all .3s;
		}
		.slider-left-leave{
			transition: opacity .3s;
			opacity: 0;
		}
	}
</style>
